import React, { useMemo } from "react";

export default function Contact() {
  // Keep the address obfuscated in source; decode only at runtime.
  const email = useMemo(() => {
    const u = atob("YWxleGFuZGVy");
    const d = atob("YXByZWxraW4uY29t");
    return `${u}@${d}`;
  }, []);

  const mobile = "+49 174 34 10 721";
  const linkedin = "https://www.linkedin.com/in/aprelkin/";
  const mailto = `mailto:${email}`;

  return (
    <section id="contact" className="contact-section text-white py-5">
      <div className="container">
        <div className="text-center mb-0">
          <h2 className="text-uppercase text-white mb-0">Contact</h2>
        </div>

        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-inner">
              <div className="contact-line">
                <span className="contact-k">Email</span>
                <a href={mailto} className="contact-v">{email}</a>
              </div>

              <div className="contact-line">
                <span className="contact-k">Mobile</span>
                <span className="contact-v">{mobile}</span>
              </div>

              <div className="contact-line">
                <span className="contact-k">LinkedIn</span>
                <a href={linkedin} className="contact-v" target="_blank" rel="noreferrer">
                  Profile
                </a>
              </div>

              <div className="contact-mini text-white-50">Munich - Remote - Deutsch/English</div>


            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
